/* src/app/modules/print-cards/components/cards/backgrounds/business-cards-2x3/harelquin-business-card-stack-background/harlequin-business-card-stack-background.component.scss */
:host {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: stretch;
  box-sizing: border-box;
  padding-left: 6.375rem;
}
:host .main-content {
  flex: 1;
}
:host .main-content .print-card-background-asset {
  height: 100%;
  width: 100%;
}
/*# sourceMappingURL=harlequin-business-card-stack-background.component.css.map */
